import React from 'react';
import classNames from 'classnames';
import styles from './Footer.module.scss';
import { UI_Grid } from 'ui/components/4-habitats/Grid/Grid';
import { UI_GridCell } from 'ui/components/4-habitats/Grid/GridCell';
import { UI_Container } from 'ui/components/4-habitats/Container/Container';
import { UI_Picture } from 'ui/components/1-atoms/Media/Picture/Picture';
import { UI_FooterBottomLinks } from 'ui/components/3-organisms/FooterBottomLinks/FooterBottomLinks';

export interface FooterProps {
	className?: string;
	children?: React.ReactNode;
	image?: {
		url: string;
		focalPoint?: { left: number; top: number };
		extension?: string;
	};
	imageAltText?: string;
	bottomLinks?: {
		url: string;
		name?: string;
		target?: string;
	}[];
}

export const UI_Footer = ({ className, children, image, imageAltText, bottomLinks }: FooterProps) => {
	return (
		<footer className={classNames(styles.Footer, className)} role="contentinfo">
			<UI_Container width="Standard">
				<UI_Grid wrap={true} container={true}>
					{image && (
						<UI_GridCell mobileWidth="100" desktopWidth="25">
							<div className={styles.Footer_imageContainer}>
								<UI_Picture
									url={image.url}
									altText={imageAltText}
									focalPoint={image.focalPoint}
									className={styles.Footer_image}
									imageCropping="contain"
								/>
							</div>
						</UI_GridCell>
					)}
					{React.Children.map(children, (child) => (
						<UI_GridCell mobileWidth="100" desktopWidth="25">
							{child}
						</UI_GridCell>
					))}
					{bottomLinks && (
						<>
							<UI_GridCell mobileWidth="100" desktopWidth="100">
								<UI_FooterBottomLinks links={bottomLinks} />
							</UI_GridCell>
						</>
					)}
				</UI_Grid>
			</UI_Container>
		</footer>
	);
};
